import to_px from "workflow/units/to_px"

export default ([x, y, x2, y2], conv = to_px) => ({
  x: conv(x),
  y: conv(y),
  width: conv(x2 - x),
  height: conv(y2 - y),
})
